import React from "react";

import IcomoonReact from "icomoon-react";
import iconSet from "./selection.json";
const Icon = (props) => {
  const { color = "#6f53a3", size = 32, icon, className = "" } = props;
  return (
    <IcomoonReact
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={icon}
    />
  );
};

export default Icon;
